import { generateAction } from '../builder'

const getFormats = generateAction('getFormats', 'admin/formats')
const getFormat = generateAction('getFormat', 'admin/formats/{id}')

export default {
  getFormats,
  getFormat,
}
